"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimulationTimeStepSizeUnits = void 0;
var SimulationTimeStepSizeUnits;
(function (SimulationTimeStepSizeUnits) {
    SimulationTimeStepSizeUnits["milliseconds"] = "milliseconds";
    SimulationTimeStepSizeUnits["microsecond"] = "microsecond";
    SimulationTimeStepSizeUnits["nanosecond"] = "nanosecond";
    SimulationTimeStepSizeUnits["picosecond"] = "picosecond";
})(SimulationTimeStepSizeUnits || (exports.SimulationTimeStepSizeUnits = SimulationTimeStepSizeUnits = {}));
//# sourceMappingURL=simulation.js.map